
export default {
    install(Vue) {
      Vue.prototype.$getUserInfo = function() {
        let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
        return userInfo; 
      };
    }
  };